import { useAuth0 } from "@auth0/auth0-react";
import Grid from "@material-ui/core/Grid";
import FilterListIcon from "@material-ui/icons/FilterList";
import { DatePickerField } from "_metronic/_partials/controls";
import { ReactComponent as FilterIcon } from "assets/icons/filter-icon.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import CrossSvg from "assets/icons/svg/cross";
import { InputField, LabelField, SelectField } from "components";
import Button from "components/button/Button";
import FilterTabs from "components/filterTabs/FilterTabs";
import { MenuMultiCheckBox } from "components/MenuMultiCheckBox/MenuMultiCheckBox";
import MyButton from "components/MyButton";
import SearchComp from "components/Searchcomponent";
import { chargeStatusOptions, OverdueDaysList, paymentStatusOptions } from "constants/finance.constants";
import { useFormik } from "formik";
import { getDateFormat, getDateFormatForDatePicket } from "helper/dateFormat";
import { getCurrency } from "helper/numberFormat";
import { useSearch } from "hook";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/dist/rsuite.min.css";
import FinanceService from "../../Lib/API/Finance";

const selectControlStyles = {
  backgroundColor: "#FFFFFF",
  borderColor: "#FFFFFF",
  color: "#b5b5c3",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
};


const formatOptionLabel = ({ label, _id }) => {
  return (
    <div className="dropdown-container" key={_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};

export const FinanceFilter = ({
  filter,
  onSearchChange,
  onChargeDateChange,
  onLedgerAccountChange,
  onPaidDateChange,
  onAmountChange,
  onChargedStatusChange,
  onPaymentStatusChange,
  onOverdueDaysChange,
  onClear,
  onStatusChange,
  setTabClick,
  setFilters,
  initialFilters,
  toggle,
  setDateRange,
  setPaidRange,
  startDate,
  startPaidDate,
  endPaidDate,
  endDate,
  onFieldChange,
  onFilterGoClicked,
  setGoSetting,  
  goSetting
}) => {

  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,1})/s;
  const { searchAction } = useSearch({ action: setOnSearch });


  const [openFilter, setOpenFilter] = useState(false);
  const [ledgers, setLedgers] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [onSearch, setOnSearch] = useState("");
  const [date, setDate] = useState([]);
  const [pdDate, setPdDate] = useState([]);

  const currency = getCurrency();
  const placeholderFormat = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();


  const validate = (values) => {
    const errors = {};
    if (
      (values?.id?.length > 24 || values?.id?.length < 24) &&
      values?.id?.length !== 0
    ) {
      errors.id = "Id must be 24 characters";
    }

    return errors;
  };

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: { all_ledger_sub_data: [], ledger: [], subLedger: [] },
    validate,
    onSubmit: async (values) => { },
  });
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };


  useEffect(() => {
    if (endDate < startDate) {
      toastr.error("End Date should be greater than start date.");
      setDateRange([null, null]);
      setDate([]);
    }
  }, [endDate]);

  useEffect(() => {
    if (endPaidDate < startPaidDate) {
      toastr.error("End Date should be greater than start date.");
      setPaidRange([null, null]);
      setPdDate([]);
    }
  }, [endPaidDate]);

  useEffect(() => {
    onChargeDateChange(formik.values?.charged_date);
    onPaidDateChange(formik.values?.paid_at);
    onFieldChange("ledger",formik.values?.ledger);
    onAmountChange(formik.values?.amount);
    onChargedStatusChange(formik.values?.charge_status);
    onPaymentStatusChange(formik.values?.payment_status);
    onOverdueDaysChange(formik.values?.overdue);
    onFieldChange("subLedger", formik.values?.subLedger);
    // eslint-disable-next-line
  }, [formik.values]);
  useEffect(() => {
    async function getLedgeraccounts() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerSubLedgerList(token);
      if (res?.ledgers) {
        const arrayWithSelectAll = ['Select All', ...res?.ledgers]
        setLedgers(arrayWithSelectAll);
        setLoading(false);
      }
    }
    getLedgeraccounts();
  }, [getAccessTokenSilently]);


  const onFilterClear = () => {
    formik.setFieldValue("charged_date", undefined);
    formik.setFieldValue("ledger", []);
    formik.setFieldValue("subLedger", []);
    formik.setFieldValue("all_ledger_sub_data", []);
    formik.setFieldValue("paid_at", undefined);
    formik.setFieldValue("amount", "");
    formik.setFieldValue("charge_status", undefined);
    formik.setFieldValue("payment_status", undefined);
    formik.setFieldValue("overdue", undefined);
    setDateRange([null, null]);
    setPaidRange([null, null]);
    setDate([]);
    setPdDate([]);
    onClear();
  };

  const options =
    ledgers &&
    ledgers?.map((item) => {
      return {
        label: item.ledger_name,
        value: item._id,
      };
    });

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const filterTabs = [
    {
      title: "All",
      value: "All",
    },
    {
      title: "Charge",
      value: "charge",
      dotColor: "#FBA12C",
    },
    {
      title: "Payment",
      value: "payment",
      dotColor: "#81DC91",
    },
  ];
  useEffect(() => {
    if (toggle === "Transaction") {
      setFilters(initialFilters);
    }
  }, [toggle]);

  return (
    <div className="filteration">
      <div className="activated-ledger d-flex flex-column flex-lg-row justify-content-between mb-5 w-100">
        <div className="sub-header-functions">
          <span className="finance-filter-serach-bar">
            <SearchComp
              value={filter?.search ? filter?.search : ""}
              setSearchText={onSearchChange}
              placeholder="Search by account name, ledger account, amount"
            />
          </span>
          <div className="pl-5">
          <Button
            variant="filter"
            onClick={() => {
              setOpenFilter(!openFilter);
              setGoSetting(!setGoSetting);
            }}
            style={openFilter ? { opacity: 0.3 } : {}}
            size="md"
          >
            <FilterIcon />
            <span>Filter</span>
          </Button>
          </div>
        </div>
        <FilterTabs tabs={filterTabs} activeTab={filter?.status || "All"} onTabsChange={(tab) =>{
          onStatusChange(tab?.value);
        }}  />
      </div>
      {openFilter && (
        <div className="filter mb-10">
          <Link></Link>
          <div className=" text-right px-5 pt-5">
            <span
              className="cursor-pointer"
              onClick={() => setOpenFilter(false)}
            >
              <CrossSvg />
            </span>
          </div>
          <div className="filter-wrapper"> 
          <Grid container spacing={5} >
              <Grid item xs={12} sm={6} md={3}>
                <LabelField title={"Charged Date"} />
                <DateRangePicker
                  format={dateFormat}
                  placeholder={`${placeholderFormat}  ~  ${placeholderFormat}`}
                  cleanable={false}
                  editable={false}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  style={{
                    display: "inline-block",
                    padding: "0",
                    border: "0",
                    width: "100%",
                    color: "black",
                  }}
                  size="lg"
                  value={date}
                  onChange={(update) => {
                    setDateRange(update);
                    setDate(update);
                    formik.setFieldValue("charged_date", update);
                  }}
                />
                </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <LabelField title={"Paid Date"} />
                <DateRangePicker
                  format={dateFormat}
                  placeholder={`${placeholderFormat}  ~  ${placeholderFormat}`}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  cleanable={false}
                  editable={false}
                  style={{
                    display: "inline-block",
                    padding: "0",
                    border: "0",
                    width: "100%",
                    color: "black",
                  }}
                  size="lg"
                  value={pdDate}
                  onChange={(update) => {
                    setPaidRange(update);
                    setPdDate(update);
                    formik.setFieldValue("paid_at", update);
                  }}
                />
                </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <LabelField title={"Ledger Account"} />
                <MenuMultiCheckBox Items={ledgers} formik={formik} loading={loading} isLedger={true} field='all_ledger_sub_data' withBorder={false} width={"100%"}/>
                </Grid>
              <Grid item xs={12} sm={6} md={3}>
              <InputField
                type="number"
                {...{
                  formik,
                  title: "Amount",
                  name: "amount",
                  placeholderIcon: (
                    <span className="filter-amount-placeholder">{currency}</span>
                  ),
                  placeholder: "Amount",
                  value: formik.values?.amount,
                }}
                onKeyDown={(e) => preventArrows(e)}
                min="0"
                onChange={(e) => {
                  formik.setFieldValue(`amount`, e.target.value.match(regex)[0]);
                }}
              />
                </Grid>
          </Grid>
          <Grid container spacing={5} >
            <Grid item xs={12} sm={6} md={3}>
              <LabelField title={"Overdue Days"} />
              <Select
                {...{
                  formik,
                  name: `overdue`,
                  checkValidation: false,
                }}
                placeholder="Select"
                isClearable={formik.values?.overdue?.value ?? false}
                classNamePrefix="react-select"
                formatOptionLabel={formatOptionLabel}
                options={OverdueDaysList}
                styles={colourStyles}
                onChange={(value) => {
                  if(!value) {
                    formik.setFieldValue(`overdue`, undefined);
                    return;
                  }
                  formik.setFieldValue(`overdue`, {
                    label: value.label,
                    value: value.value,
                  });
                }}
                value={{
                  label: formik.values?.overdue?.label,
                  value: formik.values?.overdue?.value,
                }}
                components={{ DropdownIndicator }}
              />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <LabelField title={"Charged Status"} />
                <Select
                  {...{
                    formik,
                    name: `charge_status`,
                    checkValidation: false,
                  }}
                  isClearable={formik.values?.charge_status ?? false}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={chargeStatusOptions}
                  styles={colourStyles}
                  onChange={(value) => {
                    if(!value) {
                      formik.setFieldValue(`charge_status`, undefined);
                      return;
                    }
                    formik.setFieldValue(`charge_status`, value.value);
                  }}
                  value={{
                    label: formik.values?.charge_status,
                    value: formik.values?.charge_status,
                  }}
                  components={{ DropdownIndicator }}
                />
              </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <LabelField title={"Payment Status"} />
              <Select
                {...{
                  formik,
                  name: `payment_status`,
                  checkValidation: false,
                }}
                isClearable={formik.values?.payment_status ?? false}
                classNamePrefix="react-select"
                formatOptionLabel={formatOptionLabel}
                options={paymentStatusOptions}
                styles={colourStyles}
                onChange={(value) => {
                  if(!value) {
                    formik.setFieldValue(`payment_status`, undefined);
                    return;
                  }
                  formik.setFieldValue(`payment_status`, value.value);
                }}
                value={{
                  label: formik.values?.payment_status,
                  value: formik.values?.payment_status,
                }}
                components={{ DropdownIndicator }}
              />
            </Grid>
          </Grid>
          </div>
          <div className="pr-12 pl-9 pb-10 justify-content-end d-flex">
            <Button
              variant="primary-outline"
              size="md"
              onClick={onFilterClear}
              style={{ marginRight: 10, minWidth: 80 }}
            >
              Clear
            </Button>
            <Button
              variant="primary"
              size="md"
              style={{  minWidth: 80 }}
              onClick={() => {
                setOpenFilter(false);
                onFilterGoClicked();
              }}
            >
              Go
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
